// Configuration AWS Amplify pour le portail Parents
// Ces valeurs seront injectées lors du build via le script export-parents-config.sh

const userPoolId = import.meta.env.VITE_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID;

// Si pas configuré, on retourne une config vide pour éviter le crash
const awsConfig = userPoolId && userPoolClientId ? {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: {
        email: true,
      },
    },
  },
} : {};

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
export const IS_CONFIGURED = !!(userPoolId && userPoolClientId);

export default awsConfig;

